import { IconBaseProps } from "react-icons";
import { AiOutlineFile } from "react-icons/ai";

const AddFileIcon = ({ ...rest }: IconBaseProps) => {
  return <AiOutlineFile {...rest} />;
};

export default AddFileIcon;
